export interface SupportFeedbackFormValues {
  overallSupportExperience: number | null // 1-5 CSAT
  supportIssues: string[]
  supportComments: string
  consentToFollowUp: boolean
}

export const INITIAL_SUPPORT_FEEDBACK_VALUES: SupportFeedbackFormValues = {
  overallSupportExperience: null,
  supportIssues: [],
  supportComments: '',
  consentToFollowUp: false,
}
